export const documents = {
  generatingDocument: 'Document generation in progress...',
  generatingDocumentWithPdf: 'Generating document with PDF conversion...',
  generated: 'Document generated',
  deleted: 'Document deleted successfully',
  generateDocument: 'Generate document',
  selectType: 'Select document type',
  quotation: 'Quotation',
  contract: 'Contract',
  warranty: 'Warranty',
  customer: 'Customer',
  document: 'Document',
  quotationDescription: 'Generate quotation for customers',
  contractDescription: 'Generate contract for customers',
  warrantyDescription: 'Generate warranty certificate',
  selectQuotation: 'Select quotation',
  selectContract: 'Select contract',
  selectWarranty: 'Select warranty',
  selectCustomer: 'Select customer',
  selectBaseQuotation: 'Select base quotation',
  selectBaseQuotationDescription: 'Select an existing quotation to use as a base for the new document',
  noQuotationsForCustomer: 'No quotations available for this customer',
  noWarrantyTemplates: 'No warranty templates available',
  noWarrantyTemplatesDescription: 'Please upload a warranty certificate template in the templates menu first.',
  noTemplatesAvailable: 'No templates available for this type',
  skipQuotationSelection: 'Skip quotation selection',
  selectDescription: 'Select {{type}}',
  searchQuotation: 'Search quotation',
  searchCustomer: 'Search customer',
  searchWarranty: 'Search warranty',
  createdAt: 'Created: {{date}}',
  taxNumber: 'Tax number: {{number}}',
  email: 'Email: {{email}}',
  status: '{{status}}',
  organization: 'Organization',
  individual: 'Individual',
  noResults: 'No results found for the search criteria',
  noItemsAvailable: 'No items available',
  tryDifferentKeywords: 'Try different keywords',
  createNewItem: 'Create a new item to continue',
  pagination: {
    previous: 'Previous',
    next: 'Next',
    page: 'Page {{current}} of {{total}}',
    showing: 'Showing {{from}}-{{to}} of {{total}}'
  },
  statuses: {
    draft: 'Draft',
    valid: 'Valid',
    expired: 'Expired',
    success: 'Success',
    rejected: 'Rejected'
  },
  selectedDocument: 'Selected {{type}}',
  selectTemplate: 'Select contract template',
  selectWarrantyTemplate: 'Select warranty template',
  selectTemplateDescription: 'The selected contract template will be used for document generation',
  selectWarrantyTemplateDescription: 'The selected warranty template will be used for warranty certificate generation',
  templateSearchPlaceholder: 'Search contract template...',
  warrantyTemplateSearchPlaceholder: 'Search warranty template...',
  templatePreview: 'Contract template preview',
  warrantyTemplatePreview: 'Warranty template preview',
  selectedTemplate: 'Selected contract template',
  selectedWarrantyTemplate: 'Selected warranty template',
  fieldsInTemplate: '{{count}} fields in contract template',
  fieldsInWarrantyTemplate: '{{count}} fields in warranty template',
  additionalFields: 'Additional fields',
  otherFields: 'Other fields',
  errors: {
    noTemplateSelected: 'No contract template selected',
    noWarrantyTemplateSelected: 'No warranty template selected',
    noDataAvailable: 'No data available for document generation',
    generationError: 'Error occurred while generating the document',
    warrantyGenerationError: 'Error occurred while generating the warranty certificate'
  },
  generatedDocumentSuccess: 'Document generated successfully',
  generatedWarrantyDocumentSuccess: 'Warranty certificate generated successfully',
  generatedDocumentError: 'Error occurred while generating the document',
  generatedWarrantyDocumentError: 'Error occurred while generating the warranty certificate',
  warrantyData: 'Warranty data',
  warrantyNumber: 'Warranty number',
  warrantyType: 'Warranty type',
  warrantyStatus: 'Warranty status',
  productName: 'Product name',
  productCode: 'Product code',
  manufacturer: 'Manufacturer',
  model: 'Model',
  serialNumber: 'Serial number',
  batchNumber: 'Batch number',
  customerName: 'Customer name',
  customerEmail: 'Customer email',
  supplierName: 'Supplier name',
  warrantyStartDate: 'Warranty start date',
  warrantyEndDate: 'Warranty end date',
  purchaseDate: 'Purchase date',
  warrantyDuration: 'Warranty duration',
  invoiceNumber: 'Invoice number',
  purchasePrice: 'Purchase price',
  currency: 'Currency',
  warrantyTerms: 'Warranty terms',
  warrantyCoverage: 'Warranty coverage',
  warrantyExclusions: 'Warranty exclusions',
  notes: 'Notes',
  claimsCount: 'Number of claims',
  generationDate: 'Generation date',
  documentTypes: {
    contract: 'Contract',
    quotation: 'Quotation',
    warranty: 'Warranty',
    other: 'Document'
  },
  preview: {
    loaded: 'Document loaded',
    loading: 'Document loading...',
    error: 'Error occurred while loading the document',
    reload: 'Reload...',
    download: 'Download',
    browserCannotDisplay: 'The browser cannot display this document'
  },
  editValues: 'Edit values',
  filled: 'Filled',
  searchField: 'Search field...',
  field: 'Field',
  value: 'Value',
  closePreview: 'Close preview',
  generatePreview: 'Generate preview',
  regeneratePreview: 'Regenerate preview',
  clickToGeneratePreview: 'Click to generate preview',
  empty: 'Empty',
  customerData: 'Customer data',
  chooseOutputFormat: 'Choose output format',
  generating: 'Generating...',
  formatSetToDocx: 'Format set to DOCX',
  formatSetToPdf: 'Format set to DOCX and PDF',
  pdfNotImplemented: 'PDF export is not available yet',
  documentModal: {
    title: '{{name}} documents',
    documentViewer: 'Document Viewer',
    noDocuments: 'No documents available',
    noDocumentsDescription: 'No documents have been generated or uploaded yet for this item.',
    fileViewer: 'Click to open file',
    open: 'Open',
    openFile: 'Open file',
    search: 'Search document...',
    selectDocument: 'Select document',
    noResults: 'No results found for the search criteria',
    unsupportedFileFormat: 'Unsupported file format',
    documentLoadError: 'Error occurred while loading the document',
    cannotPreviewThisFormat: 'This format cannot be previewed',
    browserCannotDisplay: 'The browser cannot display this document',
  },
  templateType: 'Template type',
  searchTemplate: 'Search template...',
  templateCount: '{{count}} templates found',
  noSearchResults: 'No matching templates found',
  tryDifferentSearch: 'Try different search terms',
  generationSuccess: 'Document generated successfully',
  generationSuccessDescription: 'Your document has been generated and is ready for download',
  downloadDocument: 'Download document',
  downloadDocuments: 'Download documents',
  selectDocument: 'Select a document to generate',
  podTableViewer: 'POD Data Viewer',
  viewPodTable: 'View POD Data',
  noPodTableData: 'No POD data available',
  podAddress: 'Address',
  measurementType: 'Measurement Type',
  annualConsumption: 'Annual Consumption',
  viewRawData: 'View Raw XML Data',
  paymentDuePlaceholder: 'Enter payment deadline in days'
}
